<h1>Entregar relatório de atividades</h1>
<mat-card>
  <mat-card-content fxLayout="column" fxLayoutGap="20px">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">
      <fieldset fxFlex="100%">
        <legend>Disciplina</legend>
        <div fxLayout="column" fxLayoutGap="5px">
          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline">
              <mat-label>Disciplina</mat-label>
              <input matInput value="{{ data?.nomeDisciplina }}" readonly="readonly" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Código</mat-label>
              <input matInput value="{{ data?.codigoDisciplina }}" readonly="readonly" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Semestre</mat-label>
              <input matInput value="{{ data?.semestre }}" readonly="readonly" />
            </mat-form-field>
          </div>

          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline">
              <mat-label>Duração</mat-label>
              <input matInput value="{{ data?.duracao }}" readonly="readonly" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Carga horária</mat-label>
              <input matInput value="{{ data?.cargaHoraria }}" readonly="readonly" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Departamento</mat-label>
              <input matInput value="{{ data?.departamentoDisciplina }}" readonly="readonly" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Unidade</mat-label>
              <input matInput value="{{ data?.campusDisciplina }} - {{ data?.siglaDisciplina }}" readonly="readonly" />
            </mat-form-field>
          </div>
        </div>
      </fieldset>
      <fieldset fxFlex="100%">
        <legend>Relatório de atividades</legend>
        <input
          type="file"
          formControlName="arquivo"
          #fileInput
          (change)="onFileSelected($event)"
          style="display: none" />
        <mat-form-field appearance="outline">
          <mat-label>Arquivo</mat-label>
          <input matInput value="{{ arquivoNome }}" readonly />
          <mat-icon matPrefix (click)="download()" title="Visualizar arquivo enviado" *ngIf="data?.arquivo">
            download
          </mat-icon>
          <mat-icon matSuffix (click)="fileInput.click()" title="Selecionar arquivo para enviar">
            folder_open
          </mat-icon>
        </mat-form-field>
      </fieldset>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayoutAlign="space-between center">
      <button mat-raised-button color="primary" (click)="gravar()"><mat-icon>save</mat-icon> Gravar</button>
      <button mat-stroked-button color="warn" routerLink="/discente/entregar-relatorio-atividade">
        <mat-icon>close</mat-icon> Voltar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
